import SharedStorageSubscribeStrategyInterface from "../SharedStorageSubscribeStrategyInterface.js";

class SharedStorageSubscribeStrategyRedux extends SharedStorageSubscribeStrategyInterface {
    constructor(storageAgent, reduxStorePromise) {
        super();
        this.storageAgent = storageAgent;
        this.reduxStorePromise = reduxStorePromise;
    }

    subscribe = async (key, onChange) => {
        const store = await this._getStore();

        const wrappedOnChange = (value) => {
            if (value?._redux_value_undefined) return onChange(undefined);
            return onChange(value);
        }
        
        // subscribe to the key
        let curValue = await this.storageAgent.get(key);
        const unsubscribe = store.subscribe(async () => {
            const prevValue = curValue;
            curValue = await this.storageAgent.get(key);
    
            // if the value of the key has changed, then call onChange
            if (prevValue !== curValue) {
                wrappedOnChange(curValue)
            }
        })
    
        // call onChange immediately when subscribed
        wrappedOnChange(curValue)
    
        return unsubscribe;
    }
    
    _getStore = async () => {
        return await Promise.resolve(this.reduxStorePromise);
    }
}

export default SharedStorageSubscribeStrategyRedux;